import { useMutation, useQuery, useQueryClient } from "react-query";
import { Theme_Preferences } from "../../utils/constants";
import { createThemePreferencesProperties, deleteThemePreferencesProperties, getThemePreferencesProperties, updateThemePreferencesProperties } from "./ThemePreferenceProperties";

export const useThemePreferencesProperties = () =>
  useQuery(
    [Theme_Preferences ,Theme_Preferences ],
    () =>  getThemePreferencesProperties()
  );

